module.exports = __webpack_public_path__ + "img/bonus_symbol_2.fe7c1796.png";